import { Component, ElementRef, ViewChild, Input, OnDestroy, type OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormService } from '../../../../../shared/services/form.service';
import { GroupsService } from '../../../../../services/groups.service';
import { ExportMediaReportModel } from '../models/export.model';
import { environment } from '../../../../../../environments/environment';

@Component({
	selector: 'app-export-report',
	templateUrl: './export-report.component.html',
	styleUrls: ['./export-report.component.scss']
})
export class ExportReportComponent implements OnInit, OnDestroy {
	@ViewChild('myDiv') myDiv: ElementRef<HTMLElement>;
	@Input() data: any = {};
	formGroup: RxFormGroup;
	fields: any = {
		start: {
			type: 'datepicker',
			options: {
				path: 'start',
				class: 'col-sm-12',
				label: {
					text: 'Inicio',
					class: 'col-sm-12'
				}
			}
		},
		end: {
			type: 'datepicker',
			options: {
				path: 'end',
				class: 'col-sm-12',
				label: {
					text: 'Fin',
					class: 'col-sm-12'
				}
			}
		},
		groups_id: {
			type: 'select',
			options: {
				path: 'groups_id',
				multi: true,
				label: {
					text: 'Grupos de Autobuses'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		}
	};

	baseLink = `${environment.apis.base}/export`;
	link = this.baseLink;

	ref: DynamicDialogRef | undefined;
	private atComponentDestroy = new Subject();

	constructor(
		public modalRef: BsModalRef,
		private groupsService: GroupsService,
		private formService: FormService
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.formGroup = data;
			});
	}

	async ngOnInit(): Promise<void> {
		this.baseLink = `${this.baseLink}/${this.data.id}`;
		this.link = this.baseLink;
		await this.formService.transformIntoFormGroup(ExportMediaReportModel, this.data);
		const groups = await this.groupsService.getAll();
		this.fields.groups_id.options.dropdown.options = groups.response;

		const groupsSelected = groups.response.map(item => item.id);
		this.formGroup.get('groups_id').setValue(groupsSelected);

		const date = new Date(), y = date.getFullYear(), m = date.getMonth();
		const firstDay = new Date(y, m, 1);
		const lastDay = new Date(y, m + 1, 0);
		this.formGroup.get('start').setValue(firstDay);
		this.formGroup.get('end').setValue(lastDay);
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
		if (this.ref) {
			this.ref.close();
		}
	}

	/**
	 * Open a new tab with the link for the MEDIA for export xls
	 */
	submit(): void {
		const formValues = [];
		Object.keys(this.formGroup.value).forEach(key => {
			if (Array.isArray(this.formGroup.value[key])) {
				formValues.push(`${key}=${this.formGroup.value[key].join(',')}`);
			} else {
				formValues.push(`${key}=${this.formGroup.value[key]}`);
			}
		});
		this.link = `${this.baseLink}?${formValues.join('&')}`;
		const el: HTMLElement = this.myDiv.nativeElement;
		el.setAttribute('href', this.link);
    	el.click();
	}

}
